import React from 'react'
import { Modal } from 'react-bootstrap'
import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'
import { formatTemplateKey } from './emailOutboxUtils'

function EmailOutboxPreviewModal({
  show,
  onHide,
  draft,
  previewTab,
  setPreviewTab,
  onOpenTestSend,
}) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Email Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <button
              className={`nav-link ${previewTab === 'html' ? 'active' : ''}`}
              onClick={() => setPreviewTab('html')}
            >
              HTML Version
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${previewTab === 'text' ? 'active' : ''}`}
              onClick={() => setPreviewTab('text')}
            >
              Text Version
            </button>
          </li>
        </ul>

        <div className="mb-3 p-3 bg-light rounded">
          <div>
            <strong>To:</strong> {draft?.user_email}
          </div>
          <div>
            <strong>Subject:</strong> {draft?.subject}
          </div>
          <div>
            <strong>State:</strong> {formatTemplateKey(draft?.template_key)}
          </div>
          <div>
            <strong>Cycle:</strong> {draft?.cycle_key}
          </div>
          <div>
            <strong>CTA:</strong>{' '}
            <a href={draft?.cta_url} target="_blank" rel="noreferrer">
              {draft?.cta_url}
            </a>
          </div>
          <div>
            <strong>Generated:</strong>{' '}
            {draft?.generated_at &&
              new Date(draft.generated_at).toLocaleString()}
          </div>
        </div>

        <div className="alert alert-info small">
          <strong>Note:</strong> Preview shows email as generated on{' '}
          {draft?.generated_at && new Date(draft.generated_at).toLocaleString()}
        </div>

        {previewTab === 'html' ? (
          <div
            className="email-preview-html border p-3"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(draft?.html_body || ''),
            }}
          />
        ) : (
          <pre
            className="email-preview-text border p-3"
            style={{ whiteSpace: 'pre-wrap' }}
          >
            {draft?.text_body}
          </pre>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={onHide} className="btn btn-secondary">
          Close
        </button>
        <button
          onClick={() => {
            onHide()
            onOpenTestSend(draft)
          }}
          className="btn btn-primary"
        >
          🧪 Test Send
        </button>
      </Modal.Footer>
    </Modal>
  )
}

EmailOutboxPreviewModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  draft: PropTypes.shape({
    user_email: PropTypes.string,
    subject: PropTypes.string,
    template_key: PropTypes.string,
    cycle_key: PropTypes.string,
    cta_url: PropTypes.string,
    generated_at: PropTypes.string,
    html_body: PropTypes.string,
    text_body: PropTypes.string,
  }),
  previewTab: PropTypes.string.isRequired,
  setPreviewTab: PropTypes.func.isRequired,
  onOpenTestSend: PropTypes.func.isRequired,
}

export default EmailOutboxPreviewModal
